import React from 'react';

// =============================================================================
// TransactionPublisherExpandedCard (V1) — expanded-row header for each
// publisher. Plain div layout, no AntD Row/Col chrome. Shows the title on
// the left and device-type chip on the right when present.
// =============================================================================

const TransactionPublisherExpandedCard = ({ record }) => {
  if (!record) return null;

  const { extra } = record;
  if (!extra) {
    return (
      <div className="campaign-overview__expanded-note">
        Please refresh your browser to receive the latest updates.
      </div>
    );
  }

  const { title, deviceType } = extra;
  return (
    <div className="campaign-overview__expanded-row-head">
      <span className="campaign-overview__expanded-row-title mono-eyebrow">{title}</span>
      {deviceType && (
        <span className="campaign-overview__expanded-row-meta mono-eyebrow">{deviceType}</span>
      )}
    </div>
  );
};

export { TransactionPublisherExpandedCard };
